<template>
  <div class="container">
    <main-title />
    <div class="card">
      <page-title back :text="pageTitle"></page-title>
      <!-- <div class="control" v-if="showContrl">
        <div class="tabs">
          <div
            :class="`tab ` + (ruleForm.work_type == 1 ? 'active' : '')"
            @click="showData(1)"
          >
            短视频
          </div>
          <div
            :class="`tab ` + (ruleForm.work_type == 2 ? 'active' : '')"
            @click="showData(2)"
          >
            童谣
          </div>
        </div>
      </div> -->
      <div class="form">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          size="medium"
          label-position="left"
        >
          <el-form-item label="作品名称" prop="work_title">
            <el-input
              v-model="ruleForm.work_title"
              placeholder="请输入作品名称"
            ></el-input>
          </el-form-item>

          <el-form-item
            :label="'作者'"
            :prop="`authors[0].name`"
            :rules="{
              required: true,
              message: '请输入作者',
              trigger: 'blur',
            }"
          >
            <div class="inline">
              <el-input
                v-model="ruleForm.authors[0].name"
                placeholder="请输入作者名称"
                class="authors"
              >
              </el-input>
             <!-- <el-form-item label="性别：" label-width="55px" class="sex">
                <el-radio-group v-model="ruleForm.authors[0].sex">
                  <el-radio :label="`1`">男</el-radio>
                  <el-radio :label="`0`">女</el-radio>
                </el-radio-group>
              </el-form-item> -->
            </div>
          </el-form-item>
		  <el-form-item label="选择组别" prop="group_name">
		    <el-select
		      v-model="ruleForm.group_name"
		      filterable
		      placeholder="选择组别"
		    >
		      <el-option
		        v-for="item in groupList"
		        :key="item"
		        :label="item"
		        :value="item"
		      >
		      </el-option>
		    </el-select>
		  </el-form-item>
          <el-form-item label="选择年级" prop="grade">
            <el-select
              v-model="ruleForm.grade"
              filterable
              placeholder="选择年级"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="指导老师" prop="teacher">
            <el-input
              v-model="ruleForm.teacher"
              placeholder="请输入指导老师姓名"
            ></el-input>
          </el-form-item>
        <!--  <el-form-item label="联系电话" prop="teacher_phone">
            <el-input
              v-model="ruleForm.teacher_phone"
              placeholder="请输入指导老师联系电话"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item
            label="视频"
            prop="video_url"
            v-if="ruleForm.work_type == 1"
          >
            <uploader
              placeholder="选择视频文件"
              @on-success="videoSuccess"
              :file-list="videoList"
              :before-upload="beforeUpload"
              accept="video/mp4"
              type="input"
              icon="el-icon-video-camera"
            >
            </uploader>
          </el-form-item> -->
         <!-- <el-form-item label="图片" prop="pic_url">
            <uploader
              placeholder="上传照片"
              @on-success="pictureSuccess"
              :file-list="pictureList"
              accept="image/*"
              type="picture"
              :limit="2"
            >
            </uploader>
          </el-form-item> -->
          <el-form-item label="上传作品" prop="attach_url">
            <uploader
              placeholder="仅限word文档"
              @on-success="attachSuccess"
			  :before-upload="beforeUpload"
              :file-list="attachList"
              accept="application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              type="input"
            >
            </uploader>
          </el-form-item>
          <el-form-item>
            <el-button class="submit" type="danger" @click="toSave">提交</el-button>
          </el-form-item>
          <el-form-item>
            <div class="el-upload__tip">
              <i class="el-icon-warning-outline up_tip" style="transform:rotate(180deg);"></i>
              <div class="up_text">
                <p>1. 请确保您上传的作品内容已获得学生本人及其监护人同意，否则由此产生的纠纷由学校负责。</p>
                <p>2. 请确保您已审核过上传内容，不得出现违法内容。</p>
				<br/>
                <p>如有违反上述要求，组委会将取消相应作品参与资格。</p>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { save, authFile, viewWork } from "@/api/work.js";
import { telRule } from "@/utils/rules.js";
import uploader from "@/components/uploader";
export default {
  name: "addWork",
  data() {
    return {
      showContrl: true,
      videoList: [
        // {
        //   status: "success",
        //   name: "原神 2020-12-17 16-14-24.mp4",
        //   filePath: "tongsheng/files/227556/202101261230404342.mp4",
        // },
      ],
      attachList: [],
      pictureList: [],
	  groupList:['小学低年级组(1-3年级)','小学高年级组(4-6年级)','初中组','高中组'],
      gradeList: [
          { id: 1, name: "一年级" },
          { id: 2, name: "二年级" },
          { id: 3, name: "三年级" },
          { id: 4, name: "四年级" },
          { id: 5, name: "五年级" },
          { id: 6, name: "六年级" },
          { id: 7, name: "七年级" },
          { id: 8, name: "八年级" },
          { id: 9, name: "九年级" },
		  { id: 10, name: "高一" },
		  { id: 11, name: "高二" },
		  { id: 12, name: "高三" }
      ],
      ruleForm: {
        work_type: 3,
        work_title: "",
        group_name: "",
        authors: [
          {
            // sex: "1",
            name: "",
          },
        ],
        grade: "",
        teacher: "",
        teacher_phone: "",
        pic_url: "",
        attach_url: "",
        video_url: "",
      },
      rules: {
        work_title: [
          { required: true, message: "请输入作品名称", trigger: "blur" },
        ],
        group_name: [{ required: true, message: "选择组别", trigger: "change" }],
		grade: [{ required: true, message: "选择年级", trigger: "change" }],
        teacher: [
          { required: true, message: "请输入指导老师姓名", trigger: "blur" },
        ],
        video_url: [
          { required: true, message: "请上传视频文件", trigger: "change" },
        ],
        pic_url: [
          { required: true, message: "请上传1-2张作品照片", trigger: "change" },
        ],
        attach_url: [
          {
            required: true,
            message: "请上传文件仅限word文档",
            trigger: "change",
          },
        ],
        // teacher_phone: [
        //   {
        //     required: true,
        //     validator: this.telRule,
        //     trigger: "blur",
        //     words: "指导老师联系电话",
        //   },
        // ],
      },
      fileList: [],
      fullAttach: "",
      fullVideo: "",
      fullPic: [],
    };
  },
  watch: {
    "ruleForm.schoolType"(val) {
      if (val.length == 1) {
        this.ruleForm.type = val[0];
      } else if (val.length == 2) {
        this.ruleForm.type = "11";
      } else {
        this.ruleForm.type = "";
      }
    },
  },
  components: {
    uploader,
  },
  created() {
    let id = this.$route.query.id;
    if (id) {
      this.showContrl = false;
      this.viewWork(id);
    }
  },
  computed: {
    pageTitle() {
      return this.showContrl ? "添加作品": "编辑作品";
    },
  },
  methods: {
    async authFile(file) {
      let d = await authFile({ key: file });
      return d.data;
    },
    /**
     * 从作品详情中提取可编辑字段
     * @param {Object} data 作品详情接口返回数据
     * @returns {Object} 仅包含提交接口需要的字段
     */
    pickEditableData(data = {}) {
      const fields = [
        "id",
        "work_type",
        "work_title",
        "authors",
        "group_name",
        "grade",
        "teacher",
        "teacher_phone",
        "pic_url",
        "attach_url",
        "video_url",
      ];
      const result = {};
      fields.forEach((key) => {
        if (data[key] !== undefined && data[key] !== null) {
          result[key] = data[key];
        }
      });
      // authors 必须是对象数组，避免接口返回 null 时表单校验报错
      if (!Array.isArray(result.authors) || !result.authors.length) {
        delete result.authors;
      }
      return result;
    },
    viewWork(id) {
      viewWork({ id }).then((d) => {
        // 仅回填表单需要的字段，避免把 pcc、region_name 等只读字段带到提交接口
        this.ruleForm = { ...this.ruleForm, ...this.pickEditableData(d.data) };
        this.ruleForm.video_url &&
          this.authFile(this.ruleForm.video_url).then((r) => {
            this.fullVideo = r;
            this.videoList.push({
              status: "success",
              name: this.ruleForm.video_url,
              filePath: this.ruleForm.video_url,
              url: r,
            });
          });
        this.ruleForm.attach_url &&
          this.authFile(this.ruleForm.attach_url).then((r) => {
            this.fullAttach = r;
            this.attachList.push({
              status: "success",
              name: this.ruleForm.attach_url,
              filePath: this.ruleForm.attach_url,
              url: r,
            });
          });
        if (this.ruleForm.pic_url) {
          let pics = this.ruleForm.pic_url.split(",");
          pics.forEach((p) => {
            this.authFile(p).then((r) => {
              this.fullPic.push(r);
              this.pictureList.push({
                status: "success",
                name: p,
                filePath: p,
                url: r,
              });
            });
          });
        }
      });
    },
    addAuthors() {
      this.ruleForm.authors.push({
        sex: "1",
        name: "",
      });
    },
    removeAuthors(index) {
      this.ruleForm.authors.splice(index, 1);
    },
    showData(type) {
      this.ruleForm.work_type = type;
    },
    telRule(rule, value, callback) {
      telRule(rule, value, callback);
    },
    numberRule(rule, value, callback) {
      numberRule(rule, value, callback);
    },
    videoSuccess(data) {
      this.ruleForm.video_url =
        data.fileList.length > 0 ? data.fileList[0].filePath : "";
    },
    pictureSuccess(data) {
      let array = [];
      if (data.fileList.length > 0) {
        array = data.fileList.map((d) => d.filePath);
        this.ruleForm.pic_url = array.join(",");
      } else {
        this.ruleForm.pic_url = "";
      }
    },
	beforeUpload(file) {
		console.log(file);
	  const isType = file.name.toLowerCase();
	  const isLt2M = file.size / 1024 / 1024 < 20;
	  if (!isLt2M) {
	    this.$message.error('上传文件大小不能超过20MB!');
		return false;
	  }
	  if (isType.lastIndexOf('.doc') === -1 && isType.lastIndexOf('.docx') === -1) {
	    this.$message.error('上传文件仅限word格式');
		 return false;
	  }
	  return true;
	},
    attachSuccess(data) {
      this.ruleForm.attach_url =
        data.fileList.length > 0 ? data.fileList[0].filePath : "";
    },
    toSave() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$showLoading();
          save(this.ruleForm).then((d) => {
            this.$message.success("作品提交成功");
            this.$router.push("/main");
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.control {
  margin-top: 24px;
  &:after {
    content: "";
    display: block;
    clear: both;
  }
  .tabs {
    float: left;
    display: flex;
    width: 174px;
    height: 32px;
    border: 1px solid #bf3d36;
    border-radius: 4px;
    .tab {
      line-height: 30px;
      width: 100%;
      text-align: center;
      font-size: 14px;
      color: #898989;
      cursor: pointer;
      &.active {
        background-color: #bf3d36;
        color: #fff;
      }
    }
  }
  .btns {
    float: right;
  }
}
.form {
  margin: 40px auto;
  width: 540px;
  .download {
    margin-left: 20px;
    font-size: 16px;
    text-decoration: underline;
  }
  .submit {
    color: #6e3621;
    background-color: #F9E8D9;
    border-color: #6e3621;
  }
  .el-upload__tip {
    font-size: 14px;
    color: #6e3621;
    line-height: 24px;
    .up_tip {
      float: left;
      font-size: 26px;
      color: #6e3621;
    }
    .up_text {
      // padding-left: 10px;
      padding-top: 1px;
      overflow: hidden;
      color: #6e3621;
    }
    p {
      margin: 0;
      margin-left: 30px;
      text-indent: -1.15em;
    }
  }
  .submit {
    display: block;
    margin: 20px auto 0;
    width: 260px;
  }
  .inline {
    display: flex;
    .sex {
      width: 400px;
      margin-left: 30px;
      .el-radio {
        margin-right: 15px;
      }
    }
    .remove_box {
      flex-shrink: 0;
      width: 50px;
      .remove {
        margin-top: 10px;
        width: 17px;
        height: 17px;
        background: url("../../assets/icon_remove.png") no-repeat center center;
        cursor: pointer;
        &:hover {
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.download {
  i {
    font-size: 20px;
    vertical-align: middle;
    font-weight: 700;
  }
}
.inline {
  .el-radio__input {
    margin-top: -1px;
  }
  .el-radio__label {
    padding-left: 5px;
  }
}
</style>
